import React, { Fragment } from 'react'
import LegacyLink from 'components/LegacyLink'
import { SUI, BoxHeadline, Header } from 'shared/ui'
import styles from './styles.less'

export default function NoCannedReplies({ onClick, isEmptyAccount }) {
  return (
    <div className={styles.cannedReplyEmpty}>
      <SUI>
        {isEmptyAccount && (
          <Fragment>
            <Header as="div" size="small" className="header" fontWeight="bold">
              Canned replies
            </Header>
            <BoxHeadline as="div" color="light" className="body">
              Canned Replies let you save commonly used responses that you can
              add them to your conversation in just a few clicks.<br /> Creating
              them takes just a few minutes, and saves you hours in the future.
            </BoxHeadline>
          </Fragment>
        )}
        {!isEmptyAccount && (
          <BoxHeadline as="div" color="light" className="body spaced">
            No canned replies found
          </BoxHeadline>
        )}
        <LegacyLink
          as="a"
          className="ui button primary small"
          path="/groove_client/settings/ticketing/canned-replies/new"
          async={false}
          skipModal
          target="_new"
          onClick={onClick}
        >
          Create canned reply
        </LegacyLink>
      </SUI>
    </div>
  )
}
